export default "<p>input-datetime-range-control works!</p>\n"